import { HtmlEditor } from "devextreme-react";
import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { renderInformationItem } from "../productRequestPage/detail";
import { AdminPolicies } from "./type";


export const PoliciesDetailPage = forwardRef<any, { data: AdminPolicies }>((
   { data }, ref
) => {
   const localize = useSelector(getLocalized);
   return <Form
      formData={data}
      ref={ref}
   >
      <GroupItem>
         <SimpleItem
            dataField={"AccountRole"}
            label={{ text: localize.getString("accountrole") }}
            render={renderInformationItem}
         >

         </SimpleItem>
         <SimpleItem
            dataField={"AccountContractType"}
            label={{ text: localize.getString("accountContractType") }}
            render={renderInformationItem}
         >

         </SimpleItem>
         <SimpleItem
            dataField={"Title"}
            label={{ text: localize.getString("title") }}
            render={renderInformationItem}
         >

         </SimpleItem>
         <SimpleItem
            dataField={"Description"}
            label={{ text: localize.getString("description") }}
            render={(e:any) => {
                return <HtmlEditor
                  value={data.Description}
                  disabled={true}
                ></HtmlEditor>
            }}
         >

         </SimpleItem>
      </GroupItem>
   </Form>
})